import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { ref, query, orderByChild, limitToLast, onValue } from 'firebase/database';

const USER_REPORTS = 'user_reports';

/** Motivos de reporte (mismas claves que functions/common/userReports.js). */
export const USER_REPORT_REASONS = [
  { value: 'no_payment', label: 'No pagó el viaje' },
  { value: 'bad_manners', label: 'Malos modales' },
  { value: 'not_welcome', label: 'Usuario no grato' },
];

export const userReportReasonLabel = (reason) =>
  (USER_REPORT_REASONS.find((r) => r.value === reason) || {}).label || reason || '';

const finishedTs = (b) => Number((b && (b.endTime || b.tripdate || b.bookingDate)) || 0) || 0;

/** Último viaje terminado (PAID / COMPLETE) del conductor: el único que puede calificar o reportar. */
export const lastFinishedDriverBooking = (bookings, driverUid) => {
  let best = null;
  (bookings || []).forEach((b) => {
    if (!b || b.driver !== driverUid || (b.status !== 'PAID' && b.status !== 'COMPLETE')) return;
    if (!best || finishedTs(b) > finishedTs(best)) best = b;
  });
  return best;
};

const functionsHost = () => {
  const { config } = firebase;
  const settings = (store.getState().settingsdata && store.getState().settingsdata.settings) || {};
  try {
    if (typeof window !== 'undefined' && window.location && settings.CompanyWebsite === window.location.origin) {
      return window.location.origin;
    }
  } catch (e) {
    // React Native no tiene window.location de navegador
  }
  return `https://${config.projectId}.web.app`;
};

const postWithAuth = async (path, body) => {
  const { auth } = firebase;
  try {
    const idToken = await auth.currentUser.getIdToken();
    const response = await fetch(`${functionsHost()}/${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
      body: JSON.stringify(body),
    });
    const result = await response.json();
    if (result && result.success) return result;
    return { success: false, error: (result && result.error) || 'No se pudo completar la acción.' };
  } catch (error) {
    return { success: false, network: true, error: 'No se pudo contactar al servidor. Revisa tu conexión e intenta de nuevo.' };
  }
};

/** Conductor: calificar (action 'rate', rating 1–5) o reportar (action 'report', reason, comment). */
export const driverRateReportCustomer = ({ bookingId, action, rating, reason, comment }) =>
  postWithAuth('driver_rate_report_customer', { bookingId, action, rating, reason, comment });

/** Admin: 'refund' (reintegrar comisión), 'dismiss' (descartar) o 'resolve' (atendido). */
export const adminUserReportAction = ({ reportId, action, note }) =>
  postWithAuth('admin_user_report_action', { reportId, action, note });

export const subscribeUserReports = (onData, onError, limit = 500) => {
  const { database } = firebase;
  if (!database) {
    if (onError) onError(new Error('Firebase no está listo'));
    return () => {};
  }
  const q = query(ref(database, USER_REPORTS), orderByChild('createdAt'), limitToLast(limit));
  return onValue(
    q,
    (snapshot) => {
      const val = snapshot.val() || {};
      onData(
        Object.keys(val)
          .map((id) => ({ id, ...val[id] }))
          .sort((a, b) => (Number(b.createdAt) || 0) - (Number(a.createdAt) || 0))
      );
    },
    (error) => {
      if (onError) onError(error);
    }
  );
};
